export const getStyled = (theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },

  card: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderRadius: theme.shape.borderRadius / 2.5,
    boxShadow: theme.shadows[3],
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: theme.shadows[6],
    },
    background:
      theme.palette.mode === 'light'
        ? `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`
        : `linear-gradient(135deg, #1DA1F2 0%, #167BB9 100%)`,
  },

  cardContent: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },

  cardText: {
    flex: 1,
    color: '#FFF',
  },

  cardTitle: {
    fontSize: '0.875rem',
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    opacity: 0.9,
  },

  cardValue: {
    fontSize: '1.75rem',
    fontWeight: 700,
    lineHeight: 1.2,
  },

  cardIcon: {
    fontSize: '2.5rem',
    marginLeft: theme.spacing(2),
    opacity: 0.8,
    color: '#FFF',
  },

  fixedHeightPaper: {
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius * 2,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(0, 0, 0, 0.2)'
        : theme.palette.background.paper,
  },

  fixedHeightPaper2: {
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius * 2,
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(0, 0, 0, 0.2)'
        : theme.palette.background.paper,
  },

  filterSection: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius / 2.5,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(0, 0, 0, 0.2)'
        : theme.palette.background.paper,
  },

  datePickerField: {
    '& .MuiInputBase-input': {
      color:
        theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.main,
    },

    '& .MuiInputLabel-root': {
      color:
        theme.palette.mode === 'dark' ? '#ccc' : theme.palette.primary.main,
    },

    '& .MuiInputLabelRoot.Mui-focused': {
      color: theme.custom.colors.dark,
    },

    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor:
          theme.palette.mode === 'dark'
            ? '#9e9e9e'
            : theme.palette.primary.main,
      },
      '&:hover fieldset': {
        borderColor:
          theme.palette.mode === 'dark'
            ? '#e0e0e0'
            : theme.palette.primary.dark,
      },
      '&.MuiFocused fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },

    '& .MuiSvgIcon-root': {
      color:
        theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.main,
    },
  },

  checkBoxField: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    justifyContent: 'center',
  },

  checkBox: {
    transform: 'scale(0.8)',
  },

  background: {
    backgroundColor: theme.palette.mode === 'dark' ? '#15202B' : '#FFF',
  },

  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10em',
  },

  chartsDateOptions: {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        display: false,
      },
      title: {
        display: true,
        text: 'Gráfico de Conversas',
        position: 'left',
      },
      datalabels: {
        display: true,
        anchor: 'start',
        offset: -30,
        align: 'start',
        color: '#fff',
        textStrokeColor: '#000',
        textStrokeWidth: 2,
        font: {
          size: 20,
          weight: 'bold',
        },
      },
    },
  },

  chartsRushHourOptions: {
    scales: {
      x: {
        title: {
          display: true,
          text: 'Hora do Dia',
        },
      },
      y: {
        title: {
          display: true,
          text: '',
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      datalabels: {
        display: true,
        color: '#fff',
        textStrokeColor: '#000',
        textStrokeWidth: 2,
        font: {
          size: 20,
          weight: 'bold',
        },
      },
    },
  },

  chartsUserOptions: {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        display: false,
      },
      title: {
        display: true,
        text: 'Gráfico de Conversas',
        position: 'left',
      },
      datalabels: {
        display: true,
        anchor: 'start',
        offset: -30,
        align: 'start',
        color: '#fff',
        textStrokeColor: '#000',
        textStrokeWidth: 2,
        font: {
          size: 20,
          weight: 'bold',
        },
      },
    },
  },
});
